// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Static_XML_to_HTML = require("./Static_XML_to_HTML.bs.js");
var Paper = require("@mui/material/Paper").default;
var Button = require("@mui/material/Button").default;

var exampleFormattedText = "\r\n<h1>This is Heading1</h1>\r\n<h2>This is Heading2</h2>\r\n<h3>This is Heading3</h3>\r\n<h4>This is Heading4</h4>\r\n<h5>This is Heading5</h5>\r\n<h6>This is Heading6</h6>\r\nThis is a hyperlink -> <a font-weight=\"bold\" color=\"green\" href=\"https://us.metamath.org\">Metamath</a>.\r\n<hr/>\r\nText may be separated by horizontal lines.\r\n<hr/>\r\nText may be <b>bold</b>, <i>italic</i>, <span font-family=\"monospace\" font-size=\"1.25em\">monospace</span>, \r\nit may have <span font-size=\"0.6em\">different</span> <span font-size=\"1.5em\">sizes</span>\r\nand <span color=\"blue\">different</span> <span color=\"red\">colors</span>.\r\n\r\n<p>Long chunks of text may be grouped into paragraphs.</p>\r\n\r\n<ul>\r\n    <li>This is an unordered list</li>\r\n    <li>item2</li>\r\n    <li>item3</li>\r\n</ul>\r\n\r\n<ol>\r\n    <li>This is an ordered list</li>\r\n    <li>item2</li>\r\n    <li>item3</li>\r\n</ol>\r\n\r\n<table>\r\n    <tbody>\r\n        <tr><td>This</td><td>is</td></tr>\r\n        <tr><td>a</td><td>table</td></tr>\r\n    </tbody>\r\n</table>\r\n\r\n<p>Monospaced multiline text:</p>\r\n<pre>--- 2p3e5 -----------------------------\r\n1|       | 3cn      | |- 3 e. CC\r\n2|       | 2cn      | |- 2 e. CC\r\n3|       | 3p2e5    | |- ( 3 + 2 ) = 5\r\n4| 1,2,3 | addcomli | |- ( 2 + 3 ) = 5\r\n---------------------------------------</pre>\r\n";

function XML_formatting_help(Props) {
  var onClose = Props.onClose;
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: React.createElement(Expln_React_Column.make, {
                    spacing: 1,
                    children: null
                  }, React.createElement(Button, {
                        onClick: (function (param) {
                            Curry._1(onClose, undefined);
                          }),
                        variant: "contained",
                        children: "Close"
                      }), React.createElement(Paper, {
                        style: {
                          padding: "10px"
                        },
                        children: React.createElement(Static_XML_to_HTML.make, {
                              xmlStr: exampleFormattedText
                            })
                      }), React.createElement(Paper, {
                        style: {
                          padding: "10px"
                        },
                        children: React.createElement("pre", undefined, exampleFormattedText)
                      }), React.createElement(Button, {
                        onClick: (function (param) {
                            Curry._1(onClose, undefined);
                          }),
                        variant: "contained",
                        children: "Close"
                      }))
            });
}

var make = XML_formatting_help;

exports.exampleFormattedText = exampleFormattedText;
exports.make = make;
/* react Not a pure module */
